import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSnackbar } from "notistack";
import MperitoCard from "src/components/MperitoCard";
import searchIndexService from "src/services/searchIndexService";

function SearchIndexingForm() {
  const { enqueueSnackbar } = useSnackbar();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);

  const indexes = [
    {
      name: "Order",
      value: "order",
      collectionName: "orders",
    },
    {
      name: "Product",
      value: "product",
      collectionName: "products",
    },
    {
      name: "Customer",
      value: "customer",
      collectionName: "customers",
    },
  ];

  const handleOpenDialog = (index, action) => {
    setSelectedIndex(index);
    setSelectedAction(action);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedIndex(null);
    setSelectedAction(null);
  };

  const handleConfirm = async () => {
    if (!selectedIndex) return;

    try {
      if (selectedAction === "delete") {
        await searchIndexService.deleteIndex(selectedIndex.value);

        enqueueSnackbar(
          `${selectedIndex.name} index deleted successfully`,
          {
            variant: "success",
          }
        );
      }

      if (selectedAction === "reindex") {
        await searchIndexService.reIndex(
          selectedIndex.value,
          selectedIndex.collectionName
        );

        enqueueSnackbar(
          `${selectedIndex.name} re-index completed successfully`,
          {
            variant: "success",
          }
        );
      }
    } catch (error) {
      console.error("Search indexing error:", error);

      enqueueSnackbar(
        `Failed to ${
          selectedAction === "delete" ? "delete index" : "re-index"
        }`,
        {
          variant: "error",
        }
      );
    } finally {
      handleCloseDialog();
    }
  };

  return (
    <>
      <MperitoCard title="SEARCH INDEXING">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Index</strong>
                </TableCell>

                <TableCell align="center">
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {indexes.map((index) => (
                <TableRow key={index.value}>
                  <TableCell
                    sx={{
                    fontSize: "16px",
                    fontWeight: 500,
                    }}>{index.name}</TableCell>

                  <TableCell align="center">
                    <Button
                      color="secondary"
                      variant="contained"
                      onClick={() =>
                        handleOpenDialog(index, "reindex")
                      }
                      sx={{ mr: 2, minWidth: 110 }}
                    >
                      Re-index
                    </Button>

                    <Button
                      color="error"
                      variant="contained"
                      onClick={() =>
                        handleOpenDialog(index, "delete")
                      }
                      sx={{ minWidth: 130 }}
                    >
                      Delete Index
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </MperitoCard>

      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
      >
        <DialogTitle>
          Confirm {selectedAction === "delete" ? "Delete" : "Re-index"}
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to{" "}
            {selectedAction === "delete"
              ? "delete the index for"
              : "re-index"}{" "}
            <strong>{selectedIndex?.name}</strong>?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog}>
            Cancel
          </Button>

          <Button
            onClick={handleConfirm}
            color="secondary"
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SearchIndexingForm;